export class TransactionalFields {
    /**
     * TransactionalFields class.
     *
     * @param {HTMLElement} container - The container element.
     */
    constructor(container) {
        this.container = container;
    }

    /**
     * Gets the input elements.
     *
     * @returns {NodeListOf<HTMLInputElement>} The input elements.
     */
    get inputs() {
        return this.container.querySelectorAll('input');
    }

    /**
     * Toggles the visibility of the transactional fields.
     *
     * @param {boolean} isVisible - Whether the transactional fields should be visible.
     */
    toggleVisibility(isVisible = true) {
        this.container.classList.toggle('d-none', !isVisible);
    }

    /**
     * Sets the required attribute for the input elements.
     *
     * @param {boolean} isRequired - Whether the input elements should be required.
     */
    setRequired(isRequired = true) {
        const inputElements = this.container.querySelectorAll('input');
        inputElements.forEach(input => {
            input.required = isRequired;
        });
    }

}
